module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/cover"
    }
  }, [_vm._v("Brave Men, Dark Waters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/fm01"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter01"
    }
  }, [_vm._v("Chapter 1 Who Are We?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter02"
    }
  }, [_vm._v("Chapter 2 Bloody Waters—Tarawa and Normandy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter03"
    }
  }, [_vm._v("Chapter 3 From Saipan to Tokyo Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter04"
    }
  }, [_vm._v("Chapter 4 A Different Breed—Commandos from the Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter05"
    }
  }, [_vm._v("Chapter 5 New Horizons—and War in Korea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter06"
    }
  }, [_vm._v("Chapter 6 Birth of the SEALs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter07"
    }
  }, [_vm._v("Chapter 7 A Pleasant Little War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 The Men with Green Faces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 The Super SEALs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 The Lieutenant (jg) Says No")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 The March of the Jedi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 A Tiny Little Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 Target: Manuel Noriega")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 To the Persian Gulf—and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Never Fight Fair!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/fm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/fm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction SEALs: What Makes Them Tick?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 1 THE EARLY DAYS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1 MacArthur’s Frogmen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 UDT Sixteen—A Bum Rap?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 Fishnets in Korea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 The Iceberg Caper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 Big War in a Small Place")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2 THE GLORY DAYS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 Welcome Back for Gemini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 Alone in the Mid-Atlantic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 First Men from the Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 Unlucky Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 3 FROGMEN IN VIETNAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 Good Fun in North Vietnam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 Operation Jackstay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 “Heaviest Load I’ve Ever Carried”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 4 THE SEALs’ WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 A Greek Tragedy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 A Narrow Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 First Blood for Squad 2-Bravo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 The Bullfrog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 More VC than You’ll Ever Want")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 “My Worst Disaster”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19 The Sting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20 Like a Shooting Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21 “Everything Is Written Down”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22 Blowing Bunkers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23 “Something’s Happened to Mike”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24 “I Don’t Want You Operating …”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25 They Called It Bright Light")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26 A Taste for Ears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27 “Vous les Américains Sont Pires que les Français”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 5 SEALs UNDER THE SEAS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28 “Dead Before Sunrise”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29 One of Our Dolphins (SDVs) Is Missing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30 Blocking Haiphong Harbor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31 Operation Thunderhead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32 “An Electrical Shock …”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33 Target: Libya")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34 Shadowing the Achille Lauro")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35 A World-Class Swim")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 6 SEALs FROM THE SKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36 A Shocking Takeoff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37 “I Started to Black Out”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38 “Your Adrenaline Pumps”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39 “I’m Going to Jump”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40 “I Hated Every One …”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41 When Your Eyes Freeze Shut")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 7 SEALs IN ACTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42 Jump into a Dark Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43 A Beautiful Day to Go to War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 8 THE INNOVATORS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44 Birth of the STAB")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 45 Dogs on Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 46 What Do You Wear to War?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 47 SEALs: A New Generation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 48 Letting Go")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hornet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/frantmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1 The Battle of the Admirals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 Wings Over the Ocean")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 “Holy Moly! We Are in Trouble!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 One Plane, One Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 “Excess Energy” To Fly and Fight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 When Weird Things Happen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 “A Tremendous Amount of Grief”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 “A Deep-Seated Drive to Kill”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 “It Starts Raining F/A-18s on You”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/endmatter01#end_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. F/A-18 Vital Statistics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. The Author Learns to Fly Back Seat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/endmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/endmatter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From a Dark Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/frantmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART I: Birth of the Air Commandos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 The Day Thursday Came on Sunday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 The Reluctant Warriors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 A “Grandiose Scheme”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Deep in Enemy Territory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Aerial Invasion of Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: Behind the Lines in Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Carpetbaggers Are Born")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Enemy Territory—in the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 D-day and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Jack of All Trades")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Action in the South")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Final Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: Korea and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Drawdown and Rebuilding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Rebirth and Decline")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: The Longest War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 They Called It Jungle Jim")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Leading the Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Death from the Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART V: Through the Looking Glass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 The Secret War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Butterflies and Ravens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 The Third War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART VI: Son Tay and the Mayaguez")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Destination: Hanoi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 “Utter Chaos” at Tang Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART VII: Hostage Rescue Efforts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Operation Rice Bowl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Back to Teheran")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 Not Quite Ready")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 Panama—Getting It Together")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART VIII: New Challenges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 The Gulf War and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/endmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/endmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4529687c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 69
// module chunks = 0